import Api from '@/api/baseApi'
import apiGPS from '@/api/apiGPS';
import apiReport from '@/api/reportBaseAPI';

export default {
    // getDistanceTravelReport(requestBody) {
    //     return Api.post("/Reports/api/ReportData/DistanceTravelReport/Get", requestBody);
    //     // return {data:DB};
    // },
    getIgnitionOnOffReport(requestBody) {
        return Api.post("/Reports/api/ReportData/IgnitionOnOffReport/Get", requestBody);
    },
    getTravelPathReport(requestBody) {
        // return Api.post("/Reports/api/ReportData/TravelledPath/Get", requestBody);
        //  return apiGPS.get(`gpsdata/GetGPSData?IMEI_No=861693038746152&fromDate=2021-02-15&toDate=2021-02-16&interval=1`)
      return apiGPS.get(`gpsdata/GetGPSData?IMEI_No=${requestBody.IMENo}&fromDate=${requestBody.fromTime}&toDate=${requestBody.toTime}&interval=1`)
    },

    getReport(body){
        return apiReport.post("api/Report/GetReportData", body);
    },
    getDynamicReport(body){
        return Api.get("/vts/api/ReportMaster/GetReports", body);
    },

    getGeofenceId(channelKey){
        return Api.get(`/geofence/api/Geofence/GetGeofences?channelKey=${channelKey}`);
    }
}

